import { Flex, Group, Pill, Text } from '@mantine/core';
import { HiArrowUpRight } from 'react-icons/hi2';
import { useViewDataset } from '@/hooks/useViewDataset.ts';
import { useHover } from '@mantine/hooks';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import { Dataset } from '@/types/datasets.ts';
import useRetrieveDataset from '@/hooks/api/datasets/useRetrieveDataset.ts';

type props = {
  datasetId: string;
  datasetName: string;
  dataset?: Dataset;
};

const DatasetPill = ({ datasetId, datasetName, dataset }: props) => {
  const { setDatasetId, datasetModalId, setDatasetModalId } = useViewDataset();

  const { data: retrievedDataset } = useRetrieveDataset(dataset ? undefined : datasetId);

  const { hovered, ref } = useHover();

  const leftChunk = datasetName.slice(0, -8);
  const leftChunkEndWithWhitespace = leftChunk.trimEnd().length !== leftChunk.length;
  const rightChunk = datasetName.slice(-8);

  return (
    <Pill
      ref={ref}
      key={datasetId}
      size="xs"
      onClick={() => {
        if (datasetModalId) {
          setDatasetModalId(datasetId);
        } else {
          setDatasetId(datasetId);
        }
      }}
      style={{
        cursor: 'pointer',
        backgroundColor: hovered ? '#EAEAEA' : '#f1f3f5',
        minHeight: '18px',
        width: 'fit-content',
        maxWidth: '100%',
      }}
    >
      <Group
        gap={4}
        wrap="nowrap"
        justify="space-between"
        style={{ width: '100%', minWidth: 0, maxWidth: '100%' }}
        h="100%"
      >
        <Flex flex={'1 1 auto'} miw={0} align={'center'}>
          {/*{dataset && (*/}
          <Flex mr={'4px'}>
            <DatasetIcon dataset={dataset || retrievedDataset} size={'12px'} />
          </Flex>
          {/*)}*/}
          <Text
            size="10px"
            truncate
            component="span"
            lh={'12px'}
            mr={leftChunkEndWithWhitespace ? '4px' : 0}
          >
            {leftChunk}
          </Text>
          <Text size="10px" component="span" lh={'12px'} style={{ whiteSpace: 'pre' }}>
            {rightChunk}
          </Text>
        </Flex>

        <HiArrowUpRight size={8} color="#757575" strokeWidth={1.5} style={{ flexShrink: 0 }} />
      </Group>
    </Pill>
  );
};

export default DatasetPill;
